<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 9v4a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 2 13V9a.5.5 0 1 1 1 0v3.5h10V9a.5.5 0 0 1 1 0zm-6.354.354a.5.5 0 0 0 .708 0l2.5-2.5a.5.5 0 0 0-.708-.708L8.5 7.793V2a.5.5 0 1 0-1 0v5.793L5.854 6.146a.5.5 0 1 0-.708.708l2.5 2.5z"
      fill="#175FB6"
    />
  </svg>
</template>
